
import { defineComponent } from 'vue'
import Card from 'primevue/card'
import InputSwitch from 'primevue/inputswitch'
import rolesManagementTabViewDescriptor from '../../RolesManagementTabViewDescriptor.json'

export default defineComponent({
    name: 'authorizations-tab',
    components: {
        Card,
        InputSwitch
    },
    props: {
        selectedRole: {
            type: Object,
            requried: false
        },
        authList: Array,
        authCBs: Object as any
    },
    emits: ['authChanged'],
    data() {
        return {
            rolesManagementTabViewDescriptor,
            role: {} as any,
            authorizationList: [] as any,
            authorizationCBs: {} as any
        }
    },
    created() {
        this.authorizationList = this.authList as any[]
        this.authorizationCBs = this.authCBs as any[]
        this.role = { ...this.selectedRole } as any
    },
    watch: {
        selectedRole: {
            handler: function(value) {
                this.role = { ...value } as any
            },
            deep: true
        }
    },
    methods: {
        authChanged(fieldName: string, value: any) {
            this.$emit('authChanged', { fieldName, value })
        }
    }
})
